export default __webpack_public_path__ + "static/media/user.71f99a18.png";